import React, { FC, useEffect, useState } from 'react'

interface ModalProps {
  show: boolean
  iconPath?: string
  title?: string
  modalSize?: string
  wrapperClass?: string
  closeCallback?: () => void
  closeable?: boolean
  children: React.ReactElement | React.ReactElement[]
}

const Modal: FC<ModalProps> = (props) => {
  const {
    iconPath,
    title,
    show,
    modalSize,
    wrapperClass,
    closeCallback,
    closeable,
    children,
  } = props

  const closeModal = () => {
    if (!closeable || !closeCallback) return
    closeCallback()
  }

  const [scrollY, setScrollY] = useState<number>(0)

  useEffect(() => {
    const html = document.querySelector('html')
    if (!html) return
    if (show) {
      const scroll = window.scrollY
      html.classList.add('modal_open')
      html.style.top = `-${scroll}px`
      setScrollY(scroll)
    } else {
      html.classList.remove('modal_open')
      window.scrollTo(0, scrollY)
      setScrollY(0)
    }
  }, [show])

  return (
    <>
      {
        show && children && (
          <div className={`modal_wrap ${wrapperClass}`}>
            <div className={`modal_box ${modalSize} ${wrapperClass} ${show || 'none'}`}>
              {
                title ? (
                  <div className="modal_header">
                    <div className="title">
                      {
                        iconPath && (
                          <object width="40px" height="40px" type="image/svg+xml" className="title-icon" data={iconPath} aria-label="img" />
                        )
                      }
                      {
                        title?.split("\n").map((item) => (
                          <React.Fragment key={`${item}`}>
                            {item}
                            <br />
                          </React.Fragment>
                        ))
                      }
                    </div>
                    {
                      closeable && (
                        <button type="button" className="close_modal" onClick={closeModal}>
                          &times;
                        </button>
                      )
                    }
                  </div>
                ) : (
                  closeable && (
                    <button type="button" className="close_button" onClick={closeModal}>
                      &times;
                    </button>
                  )
                )
              }
              <div className="modal_body">
                {Array.isArray(children) ? children[0] : children}
              </div>
              {
                Array.isArray(children) && children[1] && (
                  <div className="modal_footer">
                    {children[1]}
                  </div>
                )
              }
            </div>
            <div className="close_screen gray" role="presentation" onClick={closeModal} />
          </div>
        )
      }
    </>
  )
}

Modal.defaultProps = {
  iconPath: undefined,
  title: undefined,
  modalSize: undefined,
  wrapperClass: undefined,
  closeCallback: undefined,
  closeable: undefined,
}

export default Modal
